import { Component, Host, h, Event, EventEmitter, Method } from '@stencil/core';

@Component({
  tag: 'eproc-ionic',
  styleUrl: 'eproc-ionic.scss',
  shadow: false,
})
export class EprocIonic {
  private cssUrls: string[] = [];
  @Event() eProcWcReady: EventEmitter<object>;
  private initialized: boolean = false;

  connectedCallback() {
    this.eProcWcReady.emit(this);
    console.log('EprocIonic connectedCallback');
  }

  @Method()
  async init(obj) {
    if (this.initialized) {
      console.warn('Already initialized');
      return;
    }
    this.initialized = true;
    this.cssUrls = obj.cssUrls || [];
  }

  render() {
    return (
      <Host>
        {this.cssUrls.map((url) => {
          return <link rel='stylesheet' href={url} />
        })}
      </Host>
    );
  }

}
